<template>
<div class="form-group">
    <label class="label-control" :for="'form-' + id">{{ label }}:</label>
    <input class="form-control" :type="type" :name="id" :id="'form-' + id" v-model="model" :required="required">
</div>
</template>

<script>
export default {
    name: 'TextInput',
    props: {
        type: {
            type: String,
            default: 'text',
        },
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number],
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        formInputResetFlag: Boolean,
    },
    data() {
        return {
            model: this.value,
        }
    },
    watch: {
        model: function () {
            this.$emit('input', this.model);
        },
        formInputResetFlag() {
            this.model = '';
        }
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TextInput.vue?5147b3a7